<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title>
          Historial Transacciones TEF
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            label="Buscar"
            single-line
          />
          <v-spacer />
        </v-card-title>
        <br>
        <v-card-text>
          <v-data-table
            :footer-props="{
              'items-per-page-text': 'filas por pagina',
            }"
            :headers="headers"
            :items="$store.state.historyTef.listTransactions"
            :search="search"
            class="elevation-1"
          >
            <template v-slot:[`item.DetalleTransaccion`]="{ item }">
              <v-dialog
                transition="dialog-bottom-transition"
                max-width="700"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="cursor: pointer"
                    color="info darken-4"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-find
                  </v-icon>
                </template>
                <template v-slot:default="dialog">
                  <v-card>
                    <v-toolbar
                      style="background-color:rgb(204 33 40);color:white !important"
                      dark
                    >
                      Detalles Transacción - {{ item.authorization_number }}
                    </v-toolbar>
                    <v-card-text>
                      <v-list dense>
                        <v-list-item-group
                          v-for="(value, key) in JSON.parse(getTransactionDataDetail(item))"
                          :key="key"
                        >
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                <strong>{{ key }}:</strong>
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                {{ value }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider />
                        </v-list-item-group>
                      </v-list>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                      <v-btn
                        text
                        @click="dialog.value = false"
                      >
                        Cerrar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
            </template>
            <template v-slot:[`item.transaction_data_json`]="{ item }">
              <v-dialog
                transition="dialog-bottom-transition"
                max-width="700"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="cursor: pointer"
                    color="success darken-4"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-code-json
                  </v-icon>
                </template>
                <template v-slot:default="dialog">
                  <v-card>
                    <v-toolbar
                      style="background-color:rgb(204 33 40);color:white !important"
                      dark
                    >
                      Json procesado DATAFAST - Transacción - {{ item.authorization_number }}
                    </v-toolbar>
                    <v-card-text>
                      <div class="text-h6">
                        <json-viewer
                          :value="item.transaction_data_json"
                          :copyable="true"
                        >
                          <template v-slot:copy>
                            <v-icon
                              style="cursor: pointer"
                              color="info darken-3"
                              class="mr-2"
                              @click="copyToClipboard(JSON.stringify(item.transaction_data_json), 'JSON')"
                            >
                              mdi-content-copy
                            </v-icon>
                            Copiar
                          </template>
                        </json-viewer>
                      </div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                      <v-btn
                        text
                        @click="dialog.value = false"
                      >
                        Cerrar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-snackbar
                    v-model="snackbar.show"
                    :color="snackbar.color"
                    timeout="2000"
                    top
                    multi-line
                    class="snackbar"
                  >
                    {{ snackbar.message }}
                    <v-btn
                      icon
                      class="snackbar-close-btn"
                      @click="snackbar.show = false"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-snackbar>
                </template>
              </v-dialog>
            </template>
            <template v-slot:[`item.hiopos_xml`]="{ item }">
              <v-dialog
                transition="dialog-bottom-transition"
                max-width="700"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="cursor: pointer"
                    color="warning darken-4"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-xml
                  </v-icon>
                </template>
                <template v-slot:default="dialog">
                  <v-card>
                    <v-toolbar
                      style="background-color:rgb(204 33 40);color:white !important"
                      dark
                    >
                      XML Hiopos - Transacción - {{ item.authorization_number }}
                    </v-toolbar>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-btn
                            icon
                            @click="copyToClipboard(item.hiopos_xml, 'XML')"
                          >
                            <v-icon>mdi-content-copy</v-icon>
                          </v-btn>
                          <p>Copiar</p>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            v-model="item.hiopos_xml"
                            auto-grow
                            readonly
                            rows="50"
                            filled
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                      <v-btn
                        text
                        @click="dialog.value = false"
                      >
                        Cerrar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-snackbar
                    v-model="snackbar.show"
                    :color="snackbar.color"
                    timeout="2000"
                    top
                    multi-line
                    class="snackbar"
                  >
                    {{ snackbar.message }}
                    <v-btn
                      icon
                      class="snackbar-close-btn"
                      @click="snackbar.show = false"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-snackbar>
                </template>
              </v-dialog>
            </template>
          </v-data-table>
        </v-card-text>
      </base-card>
    </v-col>
  </v-row>
</template>

<script>

  import { tefColumnsRoles } from '@/data/tefColumnsRoles'
  import { mapState } from 'vuex'

  export default {
    name: 'ShowTransactionHistory',
    data () {
      return {
        search: '',
        headers: tefColumnsRoles,
        snackbar: {
          show: false,
          message: '',
          color: 'success',
        },
        detailTransactionKeys: {
          authorization_number: 'Número autorización',
          hiopos_transaction_id: 'ID Transacción',
          acquirer_name: 'Nombre Adquirente',
          cardholder: 'Tarjeta Habiente',
          batch_number: 'Número lote',
          total_amount: 'Monto total transacción',
          tax_base_amount: 'Valor base IVA',
          tax_amount: 'Valor IVA',
          zero_rate_base_amount: 'Valor base cero',
          tip_amount: 'Valor propina',
          interest_amount: 'Valor interes',
          transaction_datetime: 'Fecha y hora transacción',
        },
      }
    },
    computed: {
      ...mapState('historyTef', [
        'listTransactions',
      ]),
    },
    created () {
      this.getListTransactions()
    },
    methods: {
      async getListTransactions () {
        await this.$store.dispatch('historyTef/getListTransactions')
      },
      async copyToClipboard (data, format) {
        try {
          await navigator.clipboard.writeText(data)
          this.snackbar.message = format + ' copiado al portapapeles!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (err) {
          console.error('Error al copiar al portapapeles: ', err)
          this.snackbar.message = 'Error al copiar al portapapeles.'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      },
      getTransactionDataDetail (data) {
        if (!data || typeof data !== 'object') {
          return '{}'
        }
        const selectedKeyValuePairs = Object.keys(this.detailTransactionKeys).reduce((result, originalKey) => {
          const newKey = this.detailTransactionKeys[originalKey]
          if (originalKey in data) {
            result[newKey] = data[originalKey]
          }
          return result
        }, {})

        return JSON.stringify(selectedKeyValuePairs, null, 2)
      },
    },
  }

</script>

<style>
.snackbar {
  position: relative;
}

.snackbar-close-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
